<template>
  <div class="user_info">
    <action_form
      v-if="userInfo"
      v-bind="form"
      ref="formRef"
      :collection="form.formItem"
      class="user_info_form"
    >
      <a-button block type="primary" class="psw_btn" @click="showPasswordModal">
        修改密码
      </a-button>
      <a-button block type="primary" class="submit_btn" @click="handelSubmit">
        保存编辑
      </a-button>
    </action_form>
    
    <!-- 修改密码对话框 -->
    <a-modal
      v-model:visible="passwordModalVisible"
      title="修改密码"
      ok-text="确认修改密码"
      cancel-text="取消"
      @ok="handlePasswordSubmit"
    >
      <a-form layout="vertical">
        <a-form-item label="旧密码">
          <a-input-password v-model:value="passwordForm.oldPassword" placeholder="请输入旧密码" />
        </a-form-item>
        <a-form-item label="新密码">
          <a-input-password v-model:value="passwordForm.newPassword" placeholder="请输入新密码" />
        </a-form-item>
        <a-form-item label="确认新密码">
          <a-input-password v-model:value="passwordForm.confirmNewPassword" placeholder="请确认新密码" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
  import {
    reactive,
    defineProps,
    defineEmits,
    defineExpose,
    toRefs,
    ref,
    watch,
    computed,
    onMounted,
  } from 'vue'
  import { useStore } from 'vuex'
  import ImgUpload from '@/components/form/img_upload'
  import action_form from '@/components/action_form'
  import { gender, yesOrNot } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  import { encrypt } from '@/utils/auth'
  import {
    createUser,
    updateUser,
    findUser,
    updateUserSelf,
    updatePswSelf,
  } from '@/api/system_manage/userManage'
  import { message } from 'ant-design-vue'
  import { int } from 'mockjs/src/mock/random/basic'

  //1、获取数据
  const store = useStore()
  const userStoreInfo = toRefs(store.state?.user.userInfo)
  const userInfo = ref()
  onMounted(() => getUser())
  async function getUser() {
    const res = await findUser({ userId: userStoreInfo.user_id.value })
    userInfo.value = res.data
  }

  //2、表单
  const form = computed(() => ({
    name: '用户信息',
    itemWidth: '500px',
    formItem: [
      // {
      //   type: 'imgUpload',
      //   field: 'visitor_face_photo',
      //   width: '100%',
      //   // defaultValue,
      //   // label: '头像',

      // },
      {
        type: 'input',
        field: 'userName',
        defaultValue: userInfo.value?.user_name,
        label: '用户名',
        disabled: true,
      },
      {
        type: 'input',
        field: 'account',
        defaultValue: userInfo.value?.account,
        label: '账号',
        disabled: true,
      },
      {
        type: 'input',
        field: 'roleNames',
        defaultValue: userInfo.value?.roleNames,
        label: '角色',
        disabled: true,
      },
      {
        type: 'select',
        field: 'departId',
        storeOptions: 'dept',
        defaultValue: userInfo.value?.depart_id,
        label: '部门',
        disabled: true,
      },
      {
        type: 'radio',
        field: 'gender',
        defaultValue: userInfo.value?.gender,
        options: constantToOptions(gender),
        label: '性别',
      },
      {
        type: 'input',
        field: 'phone',
        defaultValue: userInfo.value?.phone,
        label: '手机号码',
      }
    ],
  }))

  //3、提交编辑
  const formRef = ref()
  const config = toRefs(store.state?.user.config)
  async function handelSubmit() {
    const formData = formRef.value.formState
    /*const obj = {
      userId: userStoreInfo.user_id.value,
      ...userInfo.value,
      ...formData,
    }*/
    const obj = {
      userName: formData.userName,
      password: formData.password,
      gender: parseInt(formData.gender),
      phone: formData.phone,
    }
    const encryptedStr = encrypt(JSON.stringify(obj), config.publicKey.value)
    const res = await updateUserSelf({ content: encryptedStr })
    if (res.success) {
      message.success('编辑成功')
      store.dispatch('user/getUserInfo')
      formRef.value.formState.password = ''
    }
  }
  
  //4、修改密码相关
  const passwordModalVisible = ref(false)
  const passwordForm = reactive({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  })
  
  function showPasswordModal() {
    passwordModalVisible.value = true
  }
  
  async function handlePasswordSubmit() {
    if (!passwordForm.oldPassword || !passwordForm.newPassword || !passwordForm.confirmNewPassword) {
      message.error('请输入旧密码和新密码')
      return
    }

    if (passwordForm.oldPassword === passwordForm.newPassword) {
      message.error('新密码不能与旧密码相同')
      return
    }

    if (passwordForm.newPassword !== passwordForm.confirmNewPassword) {
      message.error('新密码和确认密码不匹配')
      return
    }

    const obj = {
      oldPassword: passwordForm.oldPassword,
      newPassword: passwordForm.newPassword,
    }
    const encryptedStr = encrypt(JSON.stringify(obj), config.publicKey.value)
    const res = await updatePswSelf({ content: encryptedStr })
    if (res.success) {
      message.success('修改密码成功，请重新登录')
      passwordModalVisible.value = false
      passwordForm.oldPassword = ''
      passwordForm.newPassword = ''
      passwordForm.confirmNewPassword = ''
      store.dispatch('user/logout')
    }
  }
</script>

<style lang="less" scoped>
  .user_info {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    .user_info_form {
      min-height: calc(100vh - 140px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      :deep(.ant-form-item) {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .submit_btn {
        height: 40px;
      }
      .psw_btn {
        height: 40px;
        margin-bottom: 8px;
        background-color: #d46b08!important;
      }
    }
  }
</style>
